// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.breadcrumb-container {
  display: flex;
  flex-direction: row;
}

.breadcrumb-heading {
  color: #fff;
  font-size: 12px;
  padding: 20px ;
}
  .sus-html canvas{
   
   padding-bottom: 50px;
    
  }
  .sus-html li{
    font-size: small;
  }
  .sus-html p{
   font-size: small;
  }
  .sus-html canvas h3{
    font-size: small;
  }
  .sus-html canvas h4{
    font-size: small;
  }
  .sus-html canvas h2{
    font-size: small;
  }
  .sus-html canvas h1{
    font-size: small;
  }
  .sus-html h3{
  
    font-size: small;
    
}
.sus-html h4{
  
  font-size: small;
  
}
.sus-html h2{
  
  font-size: small;
  
}
.sus-html h1{
  
  font-size: small;
  
}
.modal-chatbot-container2-sust {
  /* width: 75vw; */
  margin-top: 10px;
  /* margin-left: 20px; */
  /* height: 90vh; */
}
.overlay-chatbot-sust {
  /* display: flex; */
  justify-content: center;
  width: 1100px;
  align-items: center;
  /* position: fixed; */
  /* width: 100%; */
  height: 100%;
 
}
.modal-chatbot-container-sust {
  width: 45vw;
  margin-top: 10px;
  margin-right: 10px;
  /* margin-left: 20px; */
}
.main-doa-container-sust {
  width: 1100px;
  height: 300px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  margin-top: 10px;
 overflow: scroll;
  background-color: rgba(39, 40, 75, 1);
}
.doa-board-sust {
  width: 1100px;
  height: 250px;
 
  
  margin-top: 1px;
}
.modal-overlay-chatbot-sust {
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  /* position: fixed; */
  /* width: 100%; */
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.674); */
  /* z-index: 1000; */
  top: 0;
  left: 0;
}
.doa-hide-scroll-sust{
 
  margin-left: 20px;
  height: 550px;
 
}
.Heading-sust{
  color: #FFFFFF;
      font-family: 'Graphik';
      font-weight: 350;
      font-size: 11px;
      width: 102%;
      /* margin-left: 20px; */
      padding: 5px 20px;
  }
.doa-container-sust{
display: flex;
flex-direction: row;
}
.banner-container {
  position: relative;
}
.sustainabilityBanner {
  width: 98%;
  border-radius: 20px;
}
.banner-text {
  color: white;
}
.banner-heading {
  font-family: Graphik;
  font-size: 3.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 3.5rem;
  letter-spacing: 0.1875rem;
  position: absolute;
  top: 7%;
  left: 4%;
}
.banner-description {
  font-family: Graphik;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.0625rem;
  position: absolute;
  top: 51%;
  left: 4%;
  width: 42%;
}

.main-sustainability-container {
  width: 1150px;
  height: 500px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  margin-top: 10px;
  background-color: rgba(39, 40, 75, 1);
}

.sustainabilityAnalysis-report{
  padding-left: 20px;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.sustainability-card{
  background-color: #3C4069;
  border: 1px solid #747BA9;
  border-radius: 8px;
  min-width: 260px;
  height: 110px;
  margin: 10px;
}
.sustainability-card-body{
  padding: 15px 10px;
}

.sustainability-header{
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 600;
  font-size: 11px;
  line-height: 5px;
}

.sustainability-body{
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 12px;
  line-height: 5px;
}
.filter-button-sus {
    width: 22px;
    margin-left: 15px;
}
.status-dd-sus {
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #8d97dac5;
    height: 30px;
    width: 170px;
    background-color: transparent;
    margin-left: 13px;
    margin-top: 17px;
    color: aliceblue;
}
.status-sustainability{
  max-width: fit-content ;
  margin-top: -6px;
  padding: 1% 3%;
  height: fit-content;
  background-color: rgba(36, 182, 0, 1);
  color: rgba(255, 255, 255, 1);
  font-family: Graphik;
  font-size: 11px;
  font-weight: 300;
  border: none;
  border-radius: 8dvh;
}

.process-doa-button {
  border-radius: 15px;
  margin-left: 240px;
  background-color: rgba(173, 139, 255, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-decoration: none;
  font-size: 15px;
  width: 110px;
  height: 35px;
  border-style: solid;
  float: right;
  margin: 20px 10px 20px 0px;
}


/* ... existing CSS ... */

.info-icon {
  cursor: pointer;
  height: 2px;
  width: 1%;
  text-align: center;
  padding-top: 20px;
  margin-left: 848px;
}
.i-icon {
  width: 25px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.drop-sus{
  display: flex;
  flex-direction: column;
}
/* Popup styling */
.pop-up-container-holder {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 2px solid black;
  padding: 10px;
  z-index: 1000;
  color: black;
}
/* Popup styling */
.pop-up-container-holder {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 2px solid black;
  padding: 10px;
  z-index: 1000;
  color: black;
}
.upload-success-message {
  color: white;
  padding-left: 400px;
}

.pop-up-container-holder .left-popup-container {
  width: 34%;
}

.pop-up-container-holder .right-popup-container {
  width: 66%;
}

.pop-up-container-holder .left-popup-container .left-upper,
.pop-up-container-holder .right-popup-container .right-upper,
.pop-up-container-holder .left-popup-container .left-lower,
.pop-up-container-holder .right-popup-container .right-lower {
  border: 1px solid black;
  padding: 10px;
}

.pop-up-container-holder .left-popup-container .left-upper p,
.pop-up-container-holder .right-popup-container .right-upper p,
.pop-up-container-holder .left-popup-container .left-lower p,
.pop-up-container-holder .right-popup-container .right-lower p {
  margin: 0;
  padding: 5px;
  color: black;
}
.modal1 {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  margin-top: 11px;
  margin-right: 30px;
}
/* Add these styles to your CSS file */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure the loading indicator is on top of other content */
}

.loading-spinner {
  width: 50px; /* Adjust size as needed */
  height: 50px; /* Adjust size as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); /* Box shadow for a raised effect */
}

.loading-spinner .spinner-border {
  width: 2rem; /* Adjust size as needed */
  height: 2rem; /* Adjust size as needed */
  color: #6c5cd1; /* Adjust color as needed */
}

.modal-content1 {
  background: rgb(51, 56, 93);
  margin-top: 28px;
  border-radius: 15px;
 
  width: 60%;
  height: 60%;
  position: relative;
}
.modal {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  margin-top: 11px;
  margin-right: 30px;
}

.modal-content {
  background: rgb(51, 56, 93);
  margin-top: 28px;
  border-radius: 15px;
  width: 92%;
  height: 83%;
  position: relative;
}
.first-para {
  margin-bottom: 10px;
}
.modal-section {
  margin-bottom: 20px;
}
/* .points2{
      font-size: 10px;
      font-weight: 350;
      font-family: Graphik;
      color: white;
  }
  ul li {
    margin-bottom: -10px;
  } */
.top-left {
  position: absolute;
  padding-top: 20px;
  color: white;
  width: 25%;
  font-family: Graphik;
  padding-left: 10px;
  font-weight: 350;
  font-size: 10px;

  top: 0;
  left: 0;
}
.top-1 {
  color: white;
  width: 30%;
  font-family: Graphik;
  padding-top: 20px;

  font-weight: 350;
  font-size: 10px;
}
.top-2 {
  color: white;
  width: 35%;
  font-family: Graphik;
  padding-top: 20px;
  padding-left: 30px;
  font-weight: 350;
  font-size: 10px;
}
.top-3 {
  color: white;
  width: 30%;
  font-family: Graphik;
  padding-top: 20px;
  padding-left: 30px;
  font-weight: 350;
  font-size: 10px;
}
.top-right {
  position: absolute;
  height: 225px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1); /* White with 10% opacity */
  display: flex;
  padding-left: 300px;
  margin-left: 10px;
  margin-right: 10px;
  flex-direction: row;
}
.left-sec {
  border-right: 1px solid rgba(255, 255, 255, 0.1); /* White with 10% opacity */
  height: 450px;
  padding-bottom: 20px;
  padding-top: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 26%;
}
.business-Heading {
  color: white;
  padding-bottom: 10px;
  font-size: 12px;
  padding-left: 16px;
  font-weight: 500;
  font-family: Graphik;
}
.top-4 {
  width: 60%;
}
.top-5 {
  padding-left: 50px;
}
.business-items {
  font-weight: 350;
  margin-bottom: 5px;
  font-size: 10px;
}
.business-item {
  font-weight: 350;
  margin-bottom: 1px;
  font-size: 10px;
}
.bottom-left {
  position: absolute;

  color: white;
  font-family: Graphik;
  padding: 10px;

  width: 25%;
  min-height: 150px;
  bottom: 0;
  left: 0;
}
.percent-logo {
  width: 5%;
  padding-bottom: 30px;
}
.business-items-1 {
  font-weight: 350;
  font-size: 10px;
  padding-left: 14px;
}
.business-Heading-1 {
  color: white;
  font-family: Graphik;

  font-size: 12px;
  padding-left: 15px;
  font-weight: 500;
}
.business-Heading-2 {
  color: white;
  font-family: Graphik;
  padding-top: 10px;
  font-size: 12px;
  padding-left: 15px;
  font-weight: 500;
}
.business-Heading-3 {
  color: white;
  font-family: "Graphik", sans-serif;
  padding-top: 50px;
  font-size: 10px;
  padding-left: 40px;
  font-weight: 500;
}
.sri-logo {
  width: 70%;
  padding-left: 40px;
  padding-top: 10px;
}
.sub-head-1 {
  display: flex;
  flex-direction: column;
}
.percent-class {
  display: flex;
  flex-direction: row;
  padding-left: 18px;
}
.bottom-right {
  position: absolute;
  padding-top: 240px;
  display: flex;
  flex-direction: row;
  padding-left: 330px;
  color: white;
  font-family: "Graphik", sans-serif;
  min-height: 150px;
}
.sus-html td{
  color: black;
}
.sus-html th{
  color: black;
}
.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 8px 12px;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Sustainability/Sustainability.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;EACE;;GAEC,oBAAoB;;EAErB;EACA;IACE,gBAAgB;EAClB;EACA;GACC,gBAAgB;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;;AAEpB;AACA;;EAEE,gBAAgB;;AAElB;AACA;;EAEE,gBAAgB;;AAElB;AACA;;EAEE,gBAAgB;;AAElB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;;AAEd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;CACjB,gBAAgB;EACf,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,aAAa;;;EAGb,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,MAAM;EACN,OAAO;AACT;AACA;;EAEE,iBAAiB;EACjB,aAAa;;AAEf;AACA;EACE,cAAc;MACV,sBAAsB;MACtB,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,uBAAuB;MACvB,iBAAiB;EACrB;AACF;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;AAC5B;;;AAGA,yBAAyB;;AAEzB;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;;EAIE,SAAS;EACT,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,sCAAsC;EAC5E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,4DAA4D;AAC7E;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,0BAA0B;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C,EAAE,sCAAsC;EAClF,kBAAkB;EAClB,2CAA2C,EAAE,mCAAmC;AAClF;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,0BAA0B;EACxC,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;;EAEnB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;KAQK;AACL;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,MAAM;EACN,OAAO;AACT;AACA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;;EAEjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iDAAiD,EAAE,2BAA2B;EAC9E,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gDAAgD,EAAE,2BAA2B;EAC7E,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;;EAElB,YAAY;EACZ,oBAAoB;EACpB,aAAa;;EAEb,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,OAAO;AACT;AACA;EACE,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;;EAEpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["\n.breadcrumb-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.breadcrumb-heading {\n  color: #fff;\n  font-size: 12px;\n  padding: 20px ;\n}\n  .sus-html canvas{\n   \n   padding-bottom: 50px;\n    \n  }\n  .sus-html li{\n    font-size: small;\n  }\n  .sus-html p{\n   font-size: small;\n  }\n  .sus-html canvas h3{\n    font-size: small;\n  }\n  .sus-html canvas h4{\n    font-size: small;\n  }\n  .sus-html canvas h2{\n    font-size: small;\n  }\n  .sus-html canvas h1{\n    font-size: small;\n  }\n  .sus-html h3{\n  \n    font-size: small;\n    \n}\n.sus-html h4{\n  \n  font-size: small;\n  \n}\n.sus-html h2{\n  \n  font-size: small;\n  \n}\n.sus-html h1{\n  \n  font-size: small;\n  \n}\n.modal-chatbot-container2-sust {\n  /* width: 75vw; */\n  margin-top: 10px;\n  /* margin-left: 20px; */\n  /* height: 90vh; */\n}\n.overlay-chatbot-sust {\n  /* display: flex; */\n  justify-content: center;\n  width: 1100px;\n  align-items: center;\n  /* position: fixed; */\n  /* width: 100%; */\n  height: 100%;\n \n}\n.modal-chatbot-container-sust {\n  width: 45vw;\n  margin-top: 10px;\n  margin-right: 10px;\n  /* margin-left: 20px; */\n}\n.main-doa-container-sust {\n  width: 1100px;\n  height: 300px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  margin-top: 10px;\n overflow: scroll;\n  background-color: rgba(39, 40, 75, 1);\n}\n.doa-board-sust {\n  width: 1100px;\n  height: 250px;\n \n  \n  margin-top: 1px;\n}\n.modal-overlay-chatbot-sust {\n  display: flex;\n  /* justify-content: center; */\n  /* align-items: center; */\n  /* position: fixed; */\n  /* width: 100%; */\n  height: 100%;\n  /* background-color: rgba(0, 0, 0, 0.674); */\n  /* z-index: 1000; */\n  top: 0;\n  left: 0;\n}\n.doa-hide-scroll-sust{\n \n  margin-left: 20px;\n  height: 550px;\n \n}\n.Heading-sust{\n  color: #FFFFFF;\n      font-family: 'Graphik';\n      font-weight: 350;\n      font-size: 11px;\n      width: 102%;\n      /* margin-left: 20px; */\n      padding: 5px 20px;\n  }\n.doa-container-sust{\ndisplay: flex;\nflex-direction: row;\n}\n.banner-container {\n  position: relative;\n}\n.sustainabilityBanner {\n  width: 98%;\n  border-radius: 20px;\n}\n.banner-text {\n  color: white;\n}\n.banner-heading {\n  font-family: Graphik;\n  font-size: 3.25rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 3.5rem;\n  letter-spacing: 0.1875rem;\n  position: absolute;\n  top: 7%;\n  left: 4%;\n}\n.banner-description {\n  font-family: Graphik;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.0625rem;\n  position: absolute;\n  top: 51%;\n  left: 4%;\n  width: 42%;\n}\n\n.main-sustainability-container {\n  width: 1150px;\n  height: 500px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  margin-top: 10px;\n  background-color: rgba(39, 40, 75, 1);\n}\n\n.sustainabilityAnalysis-report{\n  padding-left: 20px;\n  padding-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.sustainability-card{\n  background-color: #3C4069;\n  border: 1px solid #747BA9;\n  border-radius: 8px;\n  min-width: 260px;\n  height: 110px;\n  margin: 10px;\n}\n.sustainability-card-body{\n  padding: 15px 10px;\n}\n\n.sustainability-header{\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 5px;\n}\n\n.sustainability-body{\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 5px;\n}\n.filter-button-sus {\n    width: 22px;\n    margin-left: 15px;\n}\n.status-dd-sus {\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 5px;\n    border-color: #8d97dac5;\n    height: 30px;\n    width: 170px;\n    background-color: transparent;\n    margin-left: 13px;\n    margin-top: 17px;\n    color: aliceblue;\n}\n.status-sustainability{\n  max-width: fit-content ;\n  margin-top: -6px;\n  padding: 1% 3%;\n  height: fit-content;\n  background-color: rgba(36, 182, 0, 1);\n  color: rgba(255, 255, 255, 1);\n  font-family: Graphik;\n  font-size: 11px;\n  font-weight: 300;\n  border: none;\n  border-radius: 8dvh;\n}\n\n.process-doa-button {\n  border-radius: 15px;\n  margin-left: 240px;\n  background-color: rgba(173, 139, 255, 1);\n  color: rgba(255, 255, 255, 1);\n  text-align: center;\n  text-decoration: none;\n  font-size: 15px;\n  width: 110px;\n  height: 35px;\n  border-style: solid;\n  float: right;\n  margin: 20px 10px 20px 0px;\n}\n\n\n/* ... existing CSS ... */\n\n.info-icon {\n  cursor: pointer;\n  height: 2px;\n  width: 1%;\n  text-align: center;\n  padding-top: 20px;\n  margin-left: 848px;\n}\n.i-icon {\n  width: 25px;\n}\n.modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n.drop-sus{\n  display: flex;\n  flex-direction: column;\n}\n/* Popup styling */\n.pop-up-container-holder {\n  display: none;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border: 2px solid black;\n  padding: 10px;\n  z-index: 1000;\n  color: black;\n}\n/* Popup styling */\n.pop-up-container-holder {\n  display: none;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border: 2px solid black;\n  padding: 10px;\n  z-index: 1000;\n  color: black;\n}\n.upload-success-message {\n  color: white;\n  padding-left: 400px;\n}\n\n.pop-up-container-holder .left-popup-container {\n  width: 34%;\n}\n\n.pop-up-container-holder .right-popup-container {\n  width: 66%;\n}\n\n.pop-up-container-holder .left-popup-container .left-upper,\n.pop-up-container-holder .right-popup-container .right-upper,\n.pop-up-container-holder .left-popup-container .left-lower,\n.pop-up-container-holder .right-popup-container .right-lower {\n  border: 1px solid black;\n  padding: 10px;\n}\n\n.pop-up-container-holder .left-popup-container .left-upper p,\n.pop-up-container-holder .right-popup-container .right-upper p,\n.pop-up-container-holder .left-popup-container .left-lower p,\n.pop-up-container-holder .right-popup-container .right-lower p {\n  margin: 0;\n  padding: 5px;\n  color: black;\n}\n.modal1 {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1;\n  justify-content: center;\n  align-items: center;\n  margin-left: 30px;\n  margin-top: 11px;\n  margin-right: 30px;\n}\n/* Add these styles to your CSS file */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* Ensure the loading indicator is on top of other content */\n}\n\n.loading-spinner {\n  width: 50px; /* Adjust size as needed */\n  height: 50px; /* Adjust size as needed */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */\n  border-radius: 8px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); /* Box shadow for a raised effect */\n}\n\n.loading-spinner .spinner-border {\n  width: 2rem; /* Adjust size as needed */\n  height: 2rem; /* Adjust size as needed */\n  color: #6c5cd1; /* Adjust color as needed */\n}\n\n.modal-content1 {\n  background: rgb(51, 56, 93);\n  margin-top: 28px;\n  border-radius: 15px;\n \n  width: 60%;\n  height: 60%;\n  position: relative;\n}\n.modal {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1;\n  justify-content: center;\n  align-items: center;\n  margin-left: 30px;\n  margin-top: 11px;\n  margin-right: 30px;\n}\n\n.modal-content {\n  background: rgb(51, 56, 93);\n  margin-top: 28px;\n  border-radius: 15px;\n  width: 92%;\n  height: 83%;\n  position: relative;\n}\n.first-para {\n  margin-bottom: 10px;\n}\n.modal-section {\n  margin-bottom: 20px;\n}\n/* .points2{\n      font-size: 10px;\n      font-weight: 350;\n      font-family: Graphik;\n      color: white;\n  }\n  ul li {\n    margin-bottom: -10px;\n  } */\n.top-left {\n  position: absolute;\n  padding-top: 20px;\n  color: white;\n  width: 25%;\n  font-family: Graphik;\n  padding-left: 10px;\n  font-weight: 350;\n  font-size: 10px;\n\n  top: 0;\n  left: 0;\n}\n.top-1 {\n  color: white;\n  width: 30%;\n  font-family: Graphik;\n  padding-top: 20px;\n\n  font-weight: 350;\n  font-size: 10px;\n}\n.top-2 {\n  color: white;\n  width: 35%;\n  font-family: Graphik;\n  padding-top: 20px;\n  padding-left: 30px;\n  font-weight: 350;\n  font-size: 10px;\n}\n.top-3 {\n  color: white;\n  width: 30%;\n  font-family: Graphik;\n  padding-top: 20px;\n  padding-left: 30px;\n  font-weight: 350;\n  font-size: 10px;\n}\n.top-right {\n  position: absolute;\n  height: 225px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1); /* White with 10% opacity */\n  display: flex;\n  padding-left: 300px;\n  margin-left: 10px;\n  margin-right: 10px;\n  flex-direction: row;\n}\n.left-sec {\n  border-right: 1px solid rgba(255, 255, 255, 0.1); /* White with 10% opacity */\n  height: 450px;\n  padding-bottom: 20px;\n  padding-top: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  width: 26%;\n}\n.business-Heading {\n  color: white;\n  padding-bottom: 10px;\n  font-size: 12px;\n  padding-left: 16px;\n  font-weight: 500;\n  font-family: Graphik;\n}\n.top-4 {\n  width: 60%;\n}\n.top-5 {\n  padding-left: 50px;\n}\n.business-items {\n  font-weight: 350;\n  margin-bottom: 5px;\n  font-size: 10px;\n}\n.business-item {\n  font-weight: 350;\n  margin-bottom: 1px;\n  font-size: 10px;\n}\n.bottom-left {\n  position: absolute;\n\n  color: white;\n  font-family: Graphik;\n  padding: 10px;\n\n  width: 25%;\n  min-height: 150px;\n  bottom: 0;\n  left: 0;\n}\n.percent-logo {\n  width: 5%;\n  padding-bottom: 30px;\n}\n.business-items-1 {\n  font-weight: 350;\n  font-size: 10px;\n  padding-left: 14px;\n}\n.business-Heading-1 {\n  color: white;\n  font-family: Graphik;\n\n  font-size: 12px;\n  padding-left: 15px;\n  font-weight: 500;\n}\n.business-Heading-2 {\n  color: white;\n  font-family: Graphik;\n  padding-top: 10px;\n  font-size: 12px;\n  padding-left: 15px;\n  font-weight: 500;\n}\n.business-Heading-3 {\n  color: white;\n  font-family: \"Graphik\", sans-serif;\n  padding-top: 50px;\n  font-size: 10px;\n  padding-left: 40px;\n  font-weight: 500;\n}\n.sri-logo {\n  width: 70%;\n  padding-left: 40px;\n  padding-top: 10px;\n}\n.sub-head-1 {\n  display: flex;\n  flex-direction: column;\n}\n.percent-class {\n  display: flex;\n  flex-direction: row;\n  padding-left: 18px;\n}\n.bottom-right {\n  position: absolute;\n  padding-top: 240px;\n  display: flex;\n  flex-direction: row;\n  padding-left: 330px;\n  color: white;\n  font-family: \"Graphik\", sans-serif;\n  min-height: 150px;\n}\n.sus-html td{\n  color: black;\n}\n.sus-html th{\n  color: black;\n}\n.close-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 8px 12px;\n  cursor: pointer;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
